
// any CSS you import will output into a single css file (app.css in this case)
import './styles/matratzen.discount.scss';
window.gtmid = 'GTM-K7S27ZK';
window.fbid = '1238276627023983';
import './app';

function initResponsiveVideo() {

    const video = document.getElementById("heroVideo");

    if (!video) return;

    const srcLandscape = video.dataset.srcLandscape;
    const srcPortrait = video.dataset.srcPortrait;

    if (!srcLandscape || !srcPortrait) return;

    function updateVideoSource() {

        const portrait = window.matchMedia("(max-aspect-ratio: 1/1)").matches;

        const src = portrait ? srcPortrait : srcLandscape;

        if (video.dataset.src !== src) {
            video.pause();
            video.innerHTML = `<source src="${src}">`;
            video.dataset.src = src;
            video.load();
            video.play().catch(() => {});
        }
    }

    updateVideoSource();

    window.addEventListener("resize", updateVideoSource);

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initHeaderOpacityObserver);
    } else {
        initHeaderOpacityObserver();
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initResponsiveVideo);
} else {
    initResponsiveVideo();
}

function initHeaderOpacityObserver() {

    const header = document.querySelector("header");
    const marker = document.querySelector("main");

    if (!header || !marker) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                header.classList.remove("bg-opacity-50");
            } else {
                header.classList.add("bg-opacity-50");
            }
        },
        {
            root: null,
            threshold: 0,
            rootMargin: "0px 0px -100% 0px"
        }
    );

    observer.observe(marker);
}